import React from "react";
import { lokSabhaDocuments } from "../../data/rtiDocuments";
import PdfDocumentTable from "./PdfDocumentTable";

const LokSabha = () => (
  <div className="min-w-0 flex-1">
    <h2 className="mb-4 text-[22px] font-bold text-[#006461]">Lok Sabha</h2>
    <PdfDocumentTable
      documents={lokSabhaDocuments}
      emptyMessage="No Lok Sabha documents available."
      showMissingPdfBadge
    />
  </div>
);

export default LokSabha;
